exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v--modal-overlay[data-modal=holiday-modal] {\n  background-color: rgba(0, 0, 0, 0.65);\n}\n.v--modal-overlay[data-modal=holiday-modal] .v--modal-box {\n  max-width: 100%;\n}\n.v--modal-overlay[data-modal=holiday-modal] .v--modal {\n  box-shadow: none;\n  background-color: #252525;\n}\n.v--modal-overlay[data-modal=holiday-modal] .modal-dialog {\n  top: -130px;\n}\n@media screen and (max-width: 680px) and (min-width: 320px) {\n.v--modal-overlay[data-modal=holiday-modal] .modal-dialog {\n    top: -46px !important;\n}\n}", ""]);

// exports
